import adaptation from './adaptation/';
import demo from './demo/';
import employees from './employees/';
import feedSettings from './feed-settings/';
import feedbacks from './feedbacks/';
import matrix9Box from './matrix-9-box';
import meetings from './meetings/';
import profile from './profile/';
import roadmaps from './roadmaps/';
import score from './score/';
import settings from './settings/';
import statistic from './statistic/';
import structure from './structure/';
import surveys from './surveys/';
import targets from './targets/';
import tests from './tests/';

export default {
  en: {
    ...adaptation.en,
    ...demo.en,
    ...employees.en,
    ...feedSettings.en,
    ...feedbacks.en,
    ...matrix9Box.en,
    ...meetings.en,
    ...profile.en,
    ...roadmaps.en,
    ...score.en,
    ...settings.en,
    ...statistic.en,
    ...structure.en,
    ...surveys.en,
    ...targets.en,
    ...tests.en,
  },
  ru: {
    ...adaptation.ru,
    ...demo.ru,
    ...employees.ru,
    ...feedSettings.ru,
    ...feedbacks.ru,
    ...matrix9Box.ru,
    ...meetings.ru,
    ...profile.ru,
    ...roadmaps.ru,
    ...score.ru,
    ...settings.ru,
    ...statistic.ru,
    ...structure.ru,
    ...surveys.ru,
    ...targets.ru,
    ...tests.ru,
  },
};
